import { render, staticRenderFns } from "./BlogPost.vue?vue&type=template&id=2451a612"
import script from "./BlogPost.vue?vue&type=script&lang=ts"
export * from "./BlogPost.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports